<template>
  <div class="banner" :style="{ backgroundImage: `url(${url})` }">
    <div class="banner-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: String,
  },
};
</script>

<style lang="scss" scoped>
.banner {
  height: 374px;
  background: no-repeat center;
  background-size: cover;
  position: relative;
}
.banner-content {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
